// Checks if a string is a root-relative path.
export const isRootRelativePath = (path: string): boolean => {
  // Must start with exactly one '/' followed by a non-slash character
  return path === "/" || /^\/[^/]/.test(path)
}
